import { NavigationExtras, Params } from "@angular/router";
import { createNoPropsAction, createRequestAction } from "@app/root-store/actions/action-creators";
import { TypedAction } from "@ngrx/store/src/models";
import { RouterStateUrl } from "../router.state";

export interface RouteInfo {
    path: any[];
    query?: Record<string, unknown>;
    extras?: NavigationExtras;
}

export type RouterGo = RouteInfo & TypedAction<string>;

const category = "URL";

export const routerGo = createRequestAction<RouteInfo>(category, "Go To");
export const routerBack = createNoPropsAction(category, "Back");
export const routerForward = createNoPropsAction(category, "Forward");

export const updatePageTitle = createRequestAction<{ title: string }>(category, "Update Page Title");
export const updateBackButton = createRequestAction<{ text: string; action: string; queryParams: any }>(category, "Update Back Button");
export const updateActiveRoute = createRequestAction<{
    url: string;
    queryParams: Params;
    params: Params;
    children: RouterStateUrl[];
    title: string;
}>(category, "Update Active Route");
